import * as S from '@effect/schema/Schema';
export const Tenants = S.Struct({
    data: S.Array(S.Struct({
        id: S.String,
        displayName: S.String,
    })),
});
export const parse = S.decodeUnknownEither(Tenants);
